import styles from "./RadioButton.module.css";

type RadioButtonProps = {
  className?: string;
  checked?: boolean;
};

export default function RadioButton({
  className,
  checked = false,
}: RadioButtonProps) {
  return (
    <div className={className}>
      <input
        readOnly
        className={styles.input}
        checked={checked}
        type="checkbox"
      />
      <div className={styles.buttonVisual} />
    </div>
  );
}
